import { render, staticRenderFns } from "./HeroReward.vue?vue&type=template&id=8746133a&scoped=true"
import script from "./HeroReward.vue?vue&type=script&lang=ts"
export * from "./HeroReward.vue?vue&type=script&lang=ts"
import style0 from "./HeroReward.vue?vue&type=style&index=0&id=8746133a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8746133a",
  null
  
)

export default component.exports